import { useContext } from 'react';
import ScribeContext from './ScribeContext';

const useScribeContext = () => {
  const context = useContext(ScribeContext);
  if (!context) {
    throw new Error('useScribeContext must be used within a ScribeContextProvider');
  }
  return context;
};

export default useScribeContext;
